import NoteCounter from './NoteCounter'

export default NoteCounter
